import { render, staticRenderFns } from "./Disposal.vue?vue&type=template&id=0c3dda60&scoped=true"
import script from "./Disposal.vue?vue&type=script&lang=js"
export * from "./Disposal.vue?vue&type=script&lang=js"
import style0 from "./Disposal.vue?vue&type=style&index=0&id=0c3dda60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3dda60",
  null
  
)

export default component.exports